import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
export function FinalCTA() {
  return <section id="reservar" className="relative py-32 bg-charcoal overflow-hidden" data-id="element-13">
      {/* Subtle texture/gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/20" data-id="element-14"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-rosegold/5 rounded-full blur-3xl pointer-events-none" data-id="element-15"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-16">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-4xl md:text-5xl lg:text-6xl text-ivory mb-6" data-id="element-17">
          ¿Lista para empezar tu transformación?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-rosegold text-lg md:text-xl mb-12 font-light" data-id="element-18">
          Reservá tu consulta hoy. Cupos limitados por sede.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-19">
          <button className="bg-rosegold text-white px-10 py-5 rounded-full text-lg font-medium hover:bg-rosegold-600 hover:scale-105 transition-all duration-300 shadow-soft-lg w-full sm:w-auto" data-id="element-20">
            RESERVAR MI CONSULTA AHORA →
          </button>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-8 flex items-center justify-center gap-2 text-ivory/50 text-sm" data-id="element-21">
          <Lock size={14} data-id="element-22" />
          <span data-id="element-23">
            Consulta sin compromiso · Atención personalizada · Resultados reales
          </span>
        </motion.div>
      </div>
    </section>;
}